import { NgClass } from "@angular/common";
import { Component, Input, inject } from "@angular/core";

import { COUNTRY } from "@hermes/core-app-core";
import { Country, isKorea } from "@hermes/locale";
import { SrOnlyNoSnippetDirective } from "@hermes/utils-generic-directives-sr-only-no-snippet";

@Component({
    selector: "h-footer-copyright-deprecated",
    imports: [NgClass, SrOnlyNoSnippetDirective],
    templateUrl: "./footer-copyright-deprecated.component.html",
    styleUrls: ["./footer-copyright-deprecated.component.scss"],
})
export class FooterCopyrightDeprecatedComponent {
    private country = inject<Country>(COUNTRY);

    @Input()
    public hasLightCopyright!: boolean;
    /**
     * True if locale is Korea
     */
    public isKorea = isKorea(this.country);

    /**
     * Get current Year for copyright
     */
    public year = new Date().getFullYear();
}
